import { createContext, useContext } from "react";

export const QuestionnaireCubitIdContext = createContext<string | null>(null);

export const useQuestionnaireId = () => {
  const ctx = useContext(QuestionnaireCubitIdContext);
  return ctx;
};
